/**
 * 投稿日からの経過時間を計算して文字列で返す関数
 * @param date 日付文字列
 * @returns 経過時間の文字列表現
 */
export const getElapsedTime = (date: string): string => {
  const now = new Date();
  const past = new Date(date);
  const diff = now.getTime() - past.getTime();
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) {
    return `${seconds}秒前`;
  }
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes}分前`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours}時間前`;
  }
  const days = Math.floor(hours / 24);
  if (days < 30) {
    return `${days}日前`;
  }
  const months = Math.floor(days / 30);
  if (months < 12) {
    return `${months}ヶ月前`;
  }
  const years = Math.floor(months / 12);
  return `${years}年前`;
};

/**
 * 日付を「yyyy/mm/dd」形式でフォーマットする関数
 * @param date 日付文字列
 * @returns フォーマットされた日付文字列
 */
export const formatDate = (date?: string): string => {
  if (!date) return '';
  const d = new Date(date);
  
  // 無効な日付の場合は空文字列を返す
  if (isNaN(d.getTime())) return '';
  
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${year}/${month}/${day}`;
};

/**
 * 動画の再生時間を「mm:ss」形式で表示する関数
 * @param seconds 秒単位の再生時間
 * @returns フォーマットされた再生時間文字列
 */
export const formatDuration = (seconds?: number): string => {
  if (!seconds || isNaN(seconds) || seconds < 0) return '00:00';
  
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  
  // 2桁になるよう0埋め
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');
  
  return `${formattedMinutes}:${formattedSeconds}`;
}; 